import useSWRImmutable from 'swr/immutable';

import { apiFetcher } from '../utils/fetchers';

export const useFeedbackGames = (feedbackCode: string) => {
  const { data, isLoading, error } = useSWRImmutable(
    () => `feedbacks/${feedbackCode}/games`,
    apiFetcher,
    { suspense: true }
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error
  };
};
